import { render } from "./Kanryo.vue?vue&type=template&id=67d8cb4e&scoped=true"
import script from "./Kanryo.vue?vue&type=script&lang=js"
export * from "./Kanryo.vue?vue&type=script&lang=js"

import "./Kanryo.vue?vue&type=style&index=0&id=67d8cb4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-67d8cb4e"

export default script